import MuiAppBar, { AppBarProps } from '@mui/material/AppBar';

export interface IAppBarProps extends AppBarProps {}

const AppBar = (props: IAppBarProps): JSX.Element => {
  return <MuiAppBar {...props} />;
};

export default AppBar;
